import axios from "axios";
import { resetAppStorageForLogout } from "./utils/scopedStorage";
import { resolveBaseURL } from "./apiConfig";

const api = axios.create({
  baseURL: resolveBaseURL()
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => {
    const newToken = response.headers?.["x-new-access-token"];
    if (newToken) {
      localStorage.setItem("access_token", newToken);
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      resetAppStorageForLogout();
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default api;
